import { Component, Input } from '@angular/core';
import { Customer } from '../../../models/customer';
import { Assignment } from '../../../models/assignment';

@Component({
	selector: 'app-invoice-customer-detail',
	templateUrl: 'customer-detail.template.html'
})

/**
 * Component that shows customer data
 */
export class InvoiceCustomerDetailComponent
{
	@Input() customer: Customer = new Customer();
	@Input() assignment: Assignment = new Assignment();
}



// WEBPACK FOOTER //
// ./src/app/invoices/invoice-detail/customer-detail/customer-detail.component.ts